export {
  Skeleton,
  skeletonVariants,
  type SkeletonProps,
} from "./components/Skeleton/Skeleton"
